import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios/axiosInstance";
import { json_config } from "../../utils/headers_config";

export const create_province_rule=createAsyncThunk(
    "create/provincerules",async(payload,{rejectWithValue})=>{
        try {
            const { data } = await axiosInstance.post(`/province-rules`,payload,json_config)
            return data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const get_province_rules = createAsyncThunk(
    "get/provincerules",async(property_id,{rejectWithValue})=>{
        try {
            const { data } = await axiosInstance.get(`/province-rules`,json_config)
            return data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
export const update_province_rule=createAsyncThunk(
    "update/rules",async(payload,{rejectWithValue})=>{
        try {
            const { data } = await axiosInstance.patch(`/province-rules/${payload?.id}`,payload,json_config)
            return data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
export const delete_rule=createAsyncThunk(
    "update/rules",async(rule_id,{rejectWithValue})=>{
        try {
            const { data } = await axiosInstance.delete(`/province-rules/${rule_id}`,json_config)
            return data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
export const get_single_rule=createAsyncThunk(
    "update/rules",async(rule_id,{rejectWithValue})=>{
        try {
            const { data } = await axiosInstance.get(`/province-rules/${rule_id}`,json_config)
            return data
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)
